import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { useSubmit } from '@/hooks/useSubmit';
import { FormDialog } from './FormDialog';

/**
 * Confirmation d'une action (suppression, archivage, retrait…) : onConfirm l'envoie à l'API ; réussie, onDone (le
 * dialogue est alors fermé par l'écran), sinon l'erreur de l'API s'affiche et le dialogue reste ouvert.
 */
export function ConfirmDialog({
  title,
  description,
  confirmLabel,
  confirmIcon,
  destructive = false,
  onConfirm,
  onDone,
  onClose,
}: {
  title: ReactNode;
  description: ReactNode;
  confirmLabel: string;
  confirmIcon: LucideIcon;
  destructive?: boolean;
  onConfirm: () => Promise<unknown>;
  onDone: () => void;
  onClose: () => void;
}) {
  const { submit, submitting, error } = useSubmit();

  return (
    <FormDialog
      title={title}
      description={description}
      submitLabel={confirmLabel}
      submitIcon={confirmIcon}
      destructive={destructive}
      submitting={submitting}
      error={error}
      onSubmit={() =>
        submit(async () => {
          await onConfirm();
          onDone();
        })
      }
      onClose={onClose}
    />
  );
}
